import PreviewImages from '@/common/components/adjusterReport/previewImages/PreviewImages';
import MainLayout from '@/common/components/layouts/MainLayout';
import useModal from '@/common/hooks/useModal';
import LoadingPage from '@/common/pages/LoadingPage';
import { ADJUSTER_REPORT_BODY_DAMAGE_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/bodyDamage/bodyDamageLinks';
import RepeatCapturingModal from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/damaged/vehicleImages/vehicleDamageImagePreview/RepeatCapturingModal';
import { useRemoveDamagedPartsQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/removeDamagedParts/removeDamagedPartsQueryOptions';
import useDamagedPoints from '@/modules/adjusterReportModules/IncidentParticipants/store/damagePoints/useDamagedPoints';
import { useImageFlowStore } from '@/modules/adjusterReportModules/IncidentParticipants/store/imageFlow/useImageFlowStore';
import { getBodyAdjusterImagesQueryOptions } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyAdjusterImages/getBodyAdjusterImagesQueryOptions';
import useGetOfflineImages from '@/modules/OfflineFiles/hooks/useGetOfflineImages';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';

export default function BodyVehicleServerImagePreview() {
  return (
    <MainLayout title="بیمه گذار / تصاویر وسیله نقلیه" header="titleHeader">
      <VehicleDamageServerImagePreview />
    </MainLayout>
  );
}

const VehicleDamageServerImagePreview = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { closeModal, open, openModal } = useModal();
  const { resetCameraStore } = useImageFlowStore();
  const { resetDamagedPoints } = useDamagedPoints();
  const { getCurrentFileOfflineImages, deleteOfflineFileData } =
    useGetOfflineImages();
  const {
    data: vehicleImages,
    isPending,
    isFetching,
  } = useQuery(
    getBodyAdjusterImagesQueryOptions({
      id: +(id || 0),
      enable: true,
    }),
  );

  const addDamagedPoints = () => {
    navigate(
      ADJUSTER_REPORT_BODY_DAMAGE_LINKS.BODY_DAMAGE_IMAGES({
        id: id!,
      }).ADJUSTER_VEHICLE.serverDamagedPoints,
    );
  };
  const retakePhotoModal = () => {
    openModal();
  };
  const confirmRetakePhoto = async () => {
    const file = await getCurrentFileOfflineImages({});
    if (file.hasOffline && file.offlineItem?.id) {
      deleteOfflineFileData(file.offlineItem?.id);
    }
    openModal();
    resetDamagedPoints();
    resetCameraStore();
    navigate(
      ADJUSTER_REPORT_BODY_DAMAGE_LINKS.BODY_DAMAGE_IMAGES({
        id: id!,
      }).ADJUSTER_VEHICLE.damagedPoints,
    );
  };

  const { mutateAsync: deleteImage } = useRemoveDamagedPartsQueryOptions();

  const handleDeleteDamagePointImage = (
    image_id: number,
    closeConfirmationModal?: () => void,
  ) => {
    deleteImage({ image_id, id: +id!, type: 'body' });
    closeModal();

    closeConfirmationModal?.();
    queryClient.invalidateQueries({
      queryKey: getBodyAdjusterImagesQueryOptions({
        id: +(id || 0),
        enable: true,
      }).queryKey,
    });
  };
  if (isPending || isFetching) {
    return <LoadingPage />;
  }
  return (
    <Box pt={24}>
      <PreviewImages
        userType="body"
        handleDeleteImage={handleDeleteDamagePointImage}
        addDamagePoint={addDamagedPoints}
        retakeImage={retakePhotoModal}
        images={{
          damagedImages:
            vehicleImages?.damaged_parts.map((item) => ({
              name: item.label,
              src: item.url,
              id: item.id,
              type: 'body',
            })) ?? [],
          vehicleImages:
            vehicleImages?.vehicle.map((item) => ({
              name: item.label,
              src: item.url,
            })) ?? [],
        }}
      />
      <RepeatCapturingModal
        closeModal={closeModal}
        repeatCapturing={confirmRetakePhoto}
        open={open}
      />
    </Box>
  );
};
